exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".even{\n    background-color:#e6e6e6;\n}\n\n.filter-skill-detail tr th {\n  text-align: center;\n}\n\n.filter-skill-detail tr td {\n  text-align: center;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/filter-skill-detail/filter-skill-detail.component.css
// module id = ../../../../../src/app/skill-matrix/filter-skill-detail/filter-skill-detail.component.css
// module chunks = main